import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BaseAPIClass } from '../class/baseAPI.class';
// import { BaseAPIClass } from '..';
import { Paginated } from '../model/paginated.model';
import { Rol } from '../model/rol.model';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseAPIClass {

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/users';
  }

  getAllRoles(): Observable<Rol[]> {
    return this.httpClient.get<Rol[]>(this.baseUrl + '/roles').pipe(
      map(value => {
        console.log(value);
        return value;
      }),
      shareReplay(1)
    );
  }

  getRoles(): Observable<Rol[]> {
    return this.httpClient.get<Rol[]>(this.baseUrl + '/rol');
  }

  docentes(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + '/docentes');
  }

  getEncargado(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + '/consultores');
  }
  getCiudad(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + '/habilitados');
  }

  enableUser(id: number) {
    return this.httpClient.get(this.baseUrl + '/habilitar/' + id);
  }

  getDocentes(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + '/docentes');
  }

  // users/suscripcion/{id}
  
  register(data:any){
    return this.httpClient.post(this.baseUrl + `/registro`, data).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getUsersPaginateNext(next: string): Observable<any> {
    // "http://bkcontrolturno.vaixs.org/public/api/informes/sucursal/3?page=2"
    return this.httpClient.get<any>(next);
  }

  listarUsuarios(rol: string, nombreUser: string): Observable<Paginated> {
    return this.httpClient.get<Paginated>(
      this.baseUrl + `?rol=${rol}&term=${nombreUser}`
    );
  }

  test():Observable<any>{
      return this.httpClient.get(this.baseUrl + '/test');
  }
  // users/modulos/{id}
  

  sentPdf(data: any) {
    return this.httpClient.post(this.baseUrl + `/email`, data);
  }

  logout(){
    return this.httpClient.get('/logout');
  }
}

